/**
 * @generated SignedSource<<e8c0466e29236e35b5fa80947c319762>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LeadAttributionInputObject = {
  entryPath?: string | null | undefined;
  feature?: string | null | undefined;
  landing?: string | null | undefined;
  page?: string | null | undefined;
  ref?: string | null | undefined;
  referrer?: string | null | undefined;
  utmCampaign?: string | null | undefined;
  utmContent?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmSource?: string | null | undefined;
  utmTerm?: string | null | undefined;
};
export type onboardingPage_LeadStartMutation$variables = {
  attribution?: LeadAttributionInputObject | null | undefined;
  firstName: string;
  lastName: string;
  nextStepKey?: string | null | undefined;
};
export type onboardingPage_LeadStartMutation$data = {
  readonly leadStart: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly lead: {
      readonly token: string;
    } | null | undefined;
  } | null | undefined;
};
export type onboardingPage_LeadStartMutation = {
  response: onboardingPage_LeadStartMutation$data;
  variables: onboardingPage_LeadStartMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "attribution"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "firstName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lastName"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nextStepKey"
},
v4 = [
  {
    "kind": "Variable",
    "name": "attribution",
    "variableName": "attribution"
  },
  {
    "kind": "Variable",
    "name": "firstName",
    "variableName": "firstName"
  },
  {
    "kind": "Variable",
    "name": "lastName",
    "variableName": "lastName"
  },
  {
    "kind": "Variable",
    "name": "nextStepKey",
    "variableName": "nextStepKey"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "Lead",
  "kind": "LinkedField",
  "name": "lead",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "token",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "onboardingPage_LeadStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "LeadStartMutationPayload",
        "kind": "LinkedField",
        "name": "leadStart",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "onboardingPage_LeadStartMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "LeadStartMutationPayload",
        "kind": "LinkedField",
        "name": "leadStart",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e39e39f4f55f0e80b2a95b8e67d40ca5",
    "id": null,
    "metadata": {},
    "name": "onboardingPage_LeadStartMutation",
    "operationKind": "mutation",
    "text": "mutation onboardingPage_LeadStartMutation(\n  $firstName: String!\n  $lastName: String!\n  $nextStepKey: String\n  $attribution: LeadAttributionInputObject\n) {\n  leadStart(firstName: $firstName, lastName: $lastName, nextStepKey: $nextStepKey, attribution: $attribution) {\n    lead {\n      token\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "21baf13121b9e32ff8f60669ca783779";

export default node;
